import { render, staticRenderFns } from "./pc-part-3.vue?vue&type=template&id=2052d067&scoped=true"
import script from "./pc-part-3.vue?vue&type=script&lang=js"
export * from "./pc-part-3.vue?vue&type=script&lang=js"
import style0 from "./pc-part-3.vue?vue&type=style&index=0&id=2052d067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052d067",
  null
  
)

export default component.exports